export default __webpack_public_path__ + "static/zdrowe-love-09f353fbc98bb236d948b34db2a0748c.png";